import { render, staticRenderFns } from "./individform.vue?vue&type=template&id=9cc0973e&scoped=true&"
import script from "./individform.vue?vue&type=script&lang=js&"
export * from "./individform.vue?vue&type=script&lang=js&"
import style0 from "./individform.vue?vue&type=style&index=0&id=9cc0973e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc0973e",
  null
  
)

export default component.exports